(function () {
    'use strict';

    angular.module("imApp").factory("checkListService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 541,
                    parameters: parms || {}
                });
            },
            listAutoCreateTables: function (parms) {
                return $ihttp.post({
                    method: 920,
                    parameters: parms || {}
                });
            },
            listCheckItems: function (parms) {
                return $ihttp.post({
                    method: 542,
                    parameters: parms || {}
                });
            },
            renumberCheckItems: function (edit) {
                return $ihttp.post({
                    method: 568,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 548,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
